export default "__VITE_ASSET__BuKUIS1v__"